// extracted by mini-css-extract-plugin
export default {"container":"RatingInfo-module__container___3ChNc","withTopMargin":"RatingInfo-module__withTopMargin___31ZIM"};